import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppRoutingModule} from './app-routing/app-routing.module';
import {PagesModule} from './pages/pages.module';
import {GuardsModule} from './guards/guards.module';
import {CoreModule} from './core/core.module';
import {SentryModule} from './sentry/sentry.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    CoreModule,
    SentryModule.forRoot('https://5ae05c83dd914640813d22a99d399cec@sentry.mccomp.pl/3'),
    BrowserModule,
    AppRoutingModule,
    GuardsModule,
    PagesModule,
    BrowserAnimationsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/app.module.ts